/**
 * AlmadarPostStateSyncBrowserTabsSLAlmadarPostStateSyncBrowserTabsSLPage
 *
 * Page component for AlmadarPostStateSyncBrowserTabsSLAlmadarPostStateSyncBrowserTabsSLPage
 * Path: /sl/blog/state-sync-browser-tabs
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostStateSyncBrowserTabsSLPostPageView as __AlmadarPostStateSyncBrowserTabsSLPostPageView } from '@/components/traits/AlmadarPostStateSyncBrowserTabsSLPostPageView';
import { AlmadarPostStateSyncBrowserTabsSLPostAnalyticsView as __AlmadarPostStateSyncBrowserTabsSLPostAnalyticsView } from '@/components/traits/AlmadarPostStateSyncBrowserTabsSLPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostStateSyncBrowserTabsSLAlmadarPostStateSyncBrowserTabsSLPageProps {
  // Add any page-level props here
}

export function AlmadarPostStateSyncBrowserTabsSLAlmadarPostStateSyncBrowserTabsSLPage(_props: AlmadarPostStateSyncBrowserTabsSLAlmadarPostStateSyncBrowserTabsSLPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostStateSyncBrowserTabsSLPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostStateSyncBrowserTabsSLPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostStateSyncBrowserTabsSLAlmadarPostStateSyncBrowserTabsSLPage;
